<template>
    <v-container>
      <v-form @submit.prevent="submitForm">
        <v-text-field label="Email" v-model="email" required></v-text-field>
        <v-text-field label="Contraseña" v-model="password" type="password" required></v-text-field>
        <v-btn type="submit" color="primary">Enviar</v-btn>
      </v-form>
    </v-container>
  </template>
  
  <script>
  export default {
    data() {
      return {
        email: '',
        password: '',
      };
    },
    methods: {
      async submitForm() {
        try {
          // Obtener el token de reCAPTCHA v3
          const token = await this.$recaptcha.execute('login');
          console.log('Token reCAPTCHA:', token);
  
          // Enviar el formulario con el token al backend
          const response = await this.axios.post('/api/login', {
            email: this.email,
            password: this.password,
            recaptcha_token: token, // Enviar el token al servidor
          });
  
          console.log('Respuesta del servidor:', response.data);
        } catch (error) {
          console.error('Error al enviar formulario:', error);
        }
      },
    },
  };
  </script>
  